import StartSmartWizard from "./components/StartSmartWizard";

export default function App() {
  return <StartSmartWizard />;
}
